import React, { createContext, useContext, useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import useLocal from '../hooks/useLocal';
import socketIOClient from 'socket.io-client';
import ModalContext from './ModalContext';
import usePrevious from '../hooks/usePrevious';
import { useCookies } from 'react-cookie';

const SocketContext = createContext();

const API_URL = process.env.API_URL;

export const SocketProvider = ({ children }) => {
	const { setOpen: openModal } = useContext(ModalContext);

	const [cookies, setCookie, removeCookie] = useCookies(['socketPayload']);

	const [color, setColor] = useState('green');
	const [socket, setSocket] = useState(null);
	const [connected, setConnected] = useState(false);
	const [autoOn, setAutoOn] = useState(false);
	const [payload, setPayload] = useState(null);
	const [error, setError] = useState(null);

	const { get } = useLocal();
	const user = get('user');

	const isTabletAccount =
		user?.role?.isDefault && user?.role?.name === 'default:tablet';

	const previousSocket = usePrevious(socket);

	useEffect(() => {
		if (isTabletAccount) {
			openModal('tabletView');

			if (socket && previousSocket === null) {
			} else {
			}
		}
		//if (socket && previousSocket === null && isTabletAccount) {
		//handleConnect();
		//	}
	}, [socket, isTabletAccount]);

	/*
	socketIO.on('setColor', (color) => {
		console.log('socketIO(): setColor: ', color);
		setConnected(true);
	});
*/

	useEffect(() => {
		if (socket) {
			socket?.on('connect', () => {
				setConnected(true);
			});

			socket?.on('refreshApp', () => {
				location.reload();
			});

			socket?.on('disconnect', () => {

				//removeCookie('socketPayload');
				setConnected(false);
			});
		}
	}, [socket]);

	const initialize = () => {

		const socketIO = socketIOClient(API_URL, {
			transportOptions: {
				polling: {
					extraHeaders: { Authorization: user?.jwtToken },
				},
			},
			autoConnect: false,
			reconnectionAttempts: 15,
		});

		if (cookies?.socketPayload) {
			setPayload(cookies?.socketPayload);
		}

		setSocket(socketIO);
	};

	const handleConnect = () => {
		socket?.connect();
	};

	const handleDisconnect = () => {
		socket?.disconnect();
	};

	const handleSetPayload = (payload) => {
		setCookie('socketPayload', JSON.stringify(payload));
		setPayload(payload);
	};

	return (
		<SocketContext.Provider
			value={{
				initialize,
				socket,
				connected,
				connect: handleConnect,
				disconnect: handleDisconnect,
				payload,
				setPayload: handleSetPayload,
				error,
				setError,
			}}
		>
			{children}
		</SocketContext.Provider>
	);
};

export const SocketConsumaer = SocketContext.Consumer;

export default SocketContext;
